import { useEffect } from "react";
import { useRouter } from "next/router";
import { stripGlParams } from "@/libs/locale/gl-params";

/**
 * 마케팅 피드 링크의 `?glCountry=`·`?glCurrency=` 를 들어온 뒤 주소에서 지운다 (#5858).
 *
 * 미들웨어가 이미 `bh_ccode` 로 옮겼으므로 주소에 남길 이유가 없고, 남기면 국가 선택 창으로 고른
 * 국가가 새로고침에서 되돌아간다(`stripGlParams` 주석). 다른 파라미터(gclid 등)는 그대로 둔다.
 *
 * shallow 라 `getServerSideProps` 를 다시 부르지 않는다. 크롤러는 원래 주소로 받은 응답이 전부라
 * 영향이 없다. `_app` 에서 한 번만 호출한다.
 */
export function useStripGlCountryParam() {
  const { isReady, pathname, query, replace } = useRouter();

  useEffect(() => {
    if (!isReady) return;
    const next = stripGlParams(query);
    if (!next) return;
    void replace({ pathname, query: next }, undefined, {
      shallow: true,
      scroll: false,
    });
  }, [isReady, pathname, query, replace]);
}
